import { CustomerForm } from "@/components/customers/CustomerForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useCreateCustomer } from "@/hooks/use-customers";

interface CustomerCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CustomerCreateDialog({ open, onOpenChange }: CustomerCreateDialogProps) {
  const createCustomer = useCreateCustomer();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New customer</DialogTitle>
          <DialogDescription>Add a customer to your directory.</DialogDescription>
        </DialogHeader>
        <CustomerForm
          submitLabel="Create"
          isSaving={createCustomer.isPending}
          onCancel={() => onOpenChange(false)}
          onSubmit={(values) =>
            createCustomer.mutate(values, { onSuccess: () => onOpenChange(false) })
          }
        />
      </DialogContent>
    </Dialog>
  );
}
